import _objectWithoutProperties from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import { Field as FormikField, getIn } from 'formik';
import { genId } from "../../../utils";
import { TextInput } from '../../TextInput';
import { FormGroup } from '../FormGroup'; // This is a user defined typeguard

function isChangeEvent(ev) {
  return ev && ev.target !== undefined;
}

function FormControl(_ref) {
  var disabled = _ref.disabled,
      isInline = _ref.isInline,
      label = _ref.label,
      name = _ref.name,
      id = _ref.id,
      render = _ref.render,
      required = _ref.required,
      fieldProps = _ref.fieldProps,
      groupLss = _ref.groupLss,
      labelLss = _ref.labelLss,
      description = _ref.description,
      _ref$rendersFormGroup = _ref.rendersFormGroup,
      rendersFormGroup = _ref$rendersFormGroup === void 0 ? true : _ref$rendersFormGroup;

  if (process.env.NODE_ENV !== 'production') {
    // This is a helper for simple values, for nested values the user is on their own
    if (name.indexOf('.') === -1 && getIn(fieldProps.form.initialValues, name) === undefined) {
      throw new Error("".concat(name, " is not listed in the initialValues: ").concat(JSON.stringify(fieldProps.form.initialValues)));
    }
  }

  var error = getIn(fieldProps.form.errors, name);
  var isTouched = getIn(fieldProps.form.touched, name);
  var isInvalid = !!error && !!isTouched || false;
  var descriptionId = error && isTouched || !!description ? "".concat(id, "-description") : undefined;
  var content = React.createElement(React.Fragment, null, render({
    'aria-describedby': rendersFormGroup ? descriptionId : undefined,
    'aria-invalid': isInvalid,
    disabled: disabled,
    error: error,
    id: id,
    isInvalid: isInvalid,
    isTouched: isTouched,
    name: name,
    onBlur: function onBlur(ev) {
      if (ev) {
        fieldProps.field.onBlur(ev);
      } else {
        fieldProps.form.setFieldTouched(name, true);
      }
    },
    onChange: function onChange(ev) {
      if (isChangeEvent(ev)) {
        fieldProps.field.onChange(ev);
      } else {
        fieldProps.form.setFieldValue(name, ev);
      }
    },
    value: fieldProps.field.value
  }, fieldProps.form));

  if (!rendersFormGroup) {
    return content;
  }

  return React.createElement(FormGroup, {
    disabled: disabled,
    "data-invalid": isInvalid,
    description: description,
    error: error,
    descriptionId: descriptionId,
    id: id,
    isInline: isInline,
    isInvalid: isInvalid,
    label: label,
    required: required,
    lss: groupLss,
    labelLss: labelLss
  }, content);
}

function validateAndCheckRequired(validate, isRequired, requiredMessage) {
  if (!isRequired && !validate) {
    return undefined;
  }

  return function (value) {
    // we must check the type in case value is 0
    // and skip this required validation
    if (isRequired && typeof value !== 'number' && !value) {
      return requiredMessage || 'This field is required';
    }

    return validate ? validate(value) : undefined;
  };
}
/**
 * This is the basic Field component
 */


export function Field(props) {
  var disabled = props.disabled,
      groupLss = props.groupLss,
      id = props.id,
      isInline = props.isInline,
      label = props.label,
      name = props.name,
      required = props.required,
      requiredMessage = props.requiredMessage,
      validate = props.validate,
      description = props.description,
      labelLss = props.labelLss,
      _props$rendersFormGro = props.rendersFormGroup,
      rendersFormGroup = _props$rendersFormGro === void 0 ? true : _props$rendersFormGro;
  var fieldId = id || genId(props.name);

  var _render;

  if ('render' in props) {
    _render = props.render;
  } else {
    var ref = props.ref,
        inputProps = _objectWithoutProperties(props, ["ref"]);

    _render = function render(fieldProps) {
      return React.createElement(TextInput, Object.assign({}, fieldProps, inputProps, {
        id: fieldId
      }));
    };
  }

  return React.createElement(FormikField, {
    name: name,
    validate: validateAndCheckRequired(validate, required, requiredMessage),
    render: function render(fieldProps) {
      return React.createElement(FormControl, {
        rendersFormGroup: rendersFormGroup,
        disabled: disabled,
        fieldProps: fieldProps,
        description: description,
        groupLss: groupLss,
        labelLss: labelLss,
        id: fieldId,
        isInline: isInline,
        label: label,
        name: name,
        render: _render,
        required: required
      });
    }
  });
}